import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import ReactPlayer from 'react-player/lazy';
import {
  VStack,
  Text,
  Image,
  useBreakpointValue,
  HStack,
  Pressable,
} from 'native-base';

import { SpeakerIcon } from '../../icons/SpeakerIcon';
import { MutedSpeakerIcon } from '../../icons/MutedSpeakerIcon';
import { useSegment } from '../../hooks/useSegment';

const SHOW_VIDEO_UTM_PARAMETER = 'ayble';
const TRACKING_VIDEO_MUTED = 'home_page_video_muted';
const TRACKING_VIDEO_UNMUTED = 'home_page_video_unmuted';

const heroImg = './../hero_image.png';

const LandingPageVideo = () => {
  const { track } = useSegment();
  const [muted, setMuted] = useState(true);

  return (
    <>
      <ReactPlayer
        height="600px"
        playing={true}
        muted={muted}
        url="/Ayble_Content_Creator_Maggie_Batch 1_Video 2_V2.mp4"
        width="355px"
        loop
      />
      <HStack
        alignItems={'center'}
        justifyContent={'center'}
        pl={2}
        pt={2}
        testID={'landing-page-media-video'}
      >
        <Pressable
          onPress={() => {
            track(muted ? TRACKING_VIDEO_UNMUTED : TRACKING_VIDEO_MUTED, null);
            setMuted(!muted);
          }}
        >
          {muted ? <MutedSpeakerIcon /> : <SpeakerIcon />}
        </Pressable>
        <Text italic pl={1}>
          {muted ? 'Muted' : ''}
        </Text>
      </HStack>
    </>
  );
};

const LandingPageMedia = () => {
  const location = useLocation();
  const params = new URLSearchParams(location?.search);
  const showVideo = params.get('utm_source') === SHOW_VIDEO_UTM_PARAMETER;

  const flexDir = useBreakpointValue({
    base: 'column',
    md: 'row',
  });

  return (
    <VStack
      alignItems={'flex-start'}
      justifyContent={'center'}
      p={flexDir !== 'column' ? 12 : null}
      py={flexDir === 'column' ? 8 : null}
      testID={'landing-page-media'}
    >
      {showVideo ? (
        <LandingPageVideo />
      ) : (
        <Image
          alt={'hero image'}
          resizeMode="cover"
          size={['xs', 'sm', 'md', 'lg', 'xl', 'xl']}
          source={{
            uri: heroImg,
          }}
          testID={'landing-page-media-image'}
        />
      )}
    </VStack>
  );
};

export default LandingPageMedia;
